import { Button, Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import styles from './notFound.module.scss';

export const NotFound = () => {
    return (
        <Paper className={styles.paper} elevation={4}>
            <Grid className={styles.container} container spacing={2}>
                <Grid item xl={12}>
                    <Typography className={styles.title} variant="h3" gutterBottom>
                        404
                    </Typography>
                </Grid>
                <Grid item xl={12}>
                    <Typography className={styles.bodyDesc} variant="body1" gutterBottom>
                        Não foi possível encontrar essa página.
                    </Typography>
                </Grid>
                <Grid item xl={12}>
                    <Link className={styles.linkBtn} style={{ textDecoration: 'none' }} to="/"><Button variant="contained">Voltar para o Início</Button></Link>
                </Grid>
            </Grid>
        </Paper>
    );
}